// extracted by mini-css-extract-plugin
export default {"selector_container":"styles_selector_container__5eBnQ","box_container":"styles_box_container__CYsha"};